module.exports = __webpack_public_path__ + "img/2023-01-09d_2.1f3f8e31.jpg";